import { ICommonFieldProps } from "../../../../interfaces";

const TextAreaEditCell = (props: ICommonFieldProps) => {
  const { defaultValue, onChange } = props;

  return (
    <textarea
      className="input-field"
      defaultValue={String(defaultValue ?? "")}
      rows={1}
      onChange={onChange}
      style={{ height: "100%", resize: "none" }}
    />
  );
};

export default TextAreaEditCell;
